module.exports = __webpack_public_path__ + "img/js.61ed8b05.svg";